import _slicedToArray from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/slicedToArray.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.string.ends-with.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/es6.string.iterator.js";
var utils = {
  methods: {
    /*!
    * Find the differences between two objects and push to a new object
    * (c) 2019 Chris Ferdinandi & Jascha Brinkmann, MIT License, https://gomakethings.com & https://twitter.com/jaschaio
    * @param  {Object} obj1 The original object
    * @param  {Object} obj2 The object to compare against it
    * @return {Object}      An object of differences between the two
    */
    diff: function diff(obj1, obj2) {
      var _this = this;

      // Make sure an object to compare is provided
      if (!obj2 || Object.prototype.toString.call(obj2) !== '[object Object]') {
        return obj1;
      } //
      // Variables
      //


      var diffs = {};
      var key; //
      // Methods
      //

      /**
       * Check if two arrays are equal
       * @param  {Array}   arr1 The first array
       * @param  {Array}   arr2 The second array
       * @return {Boolean}      If true, both arrays are equal
       */

      var arraysMatch = function arraysMatch(arr1, arr2) {
        // Check if the arrays are the same length
        if (arr1.length !== arr2.length) return false; // Check if all items exist and are in the same order

        for (var i = 0; i < arr1.length; i++) {
          if (arr1[i] !== arr2[i]) return false;
        } // Otherwise, return true


        return true;
      };
      /**
       * Compare two items and push non-matches to object
       * @param  {*}      item1 The first item
       * @param  {*}      item2 The second item
       * @param  {String} key   The key in our object
       */


      var compare = function compare(item1, item2, key) {
        // Get the object type
        var type1 = Object.prototype.toString.call(item1);
        var type2 = Object.prototype.toString.call(item2); // If type2 is undefined it has been removed

        if (type2 === '[object Undefined]') {
          diffs[key] = null;
          return;
        } // If items are different types


        if (type1 !== type2) {
          diffs[key] = item2;
          return;
        } // If an object, compare recursively


        if (type1 === '[object Object]') {
          var objDiff = _this.diff(item1, item2);

          if (Object.keys(objDiff).length > 0) {
            diffs[key] = objDiff;
          }

          return;
        } // If an array, compare


        if (type1 === '[object Array]') {
          if (!arraysMatch(item1, item2)) {
            diffs[key] = item2;
          }

          return;
        } // Else if it's a function, convert to a string and compare
        // Otherwise, just compare


        if (type1 === '[object Function]') {
          if (item1.toString() !== item2.toString()) {
            diffs[key] = item2;
          }
        } else {
          if (item1 !== item2) {
            diffs[key] = item2;
          }
        }
      }; //
      // Compare our objects
      //
      // Loop through the first object


      for (key in obj1) {
        // eslint-disable-next-line no-prototype-builtins
        if (obj1.hasOwnProperty(key)) {
          compare(obj1[key], obj2[key], key);
        }
      } // Loop through the second object and find missing items


      for (key in obj2) {
        // eslint-disable-next-line no-prototype-builtins
        if (obj2.hasOwnProperty(key)) {
          if (!obj1[key] && obj1[key] !== obj2[key]) {
            diffs[key] = obj2[key];
          }
        }
      } // Return the object of differences


      return diffs;
    },
    objectToQueryString: function objectToQueryString(obj) {
      return Object.keys(obj).map(function (key) {
        if (Array.isArray(obj[key])) {
          // Handle arrays by creating multiple key-value pairs for the same key
          if (obj[key].length === 0) return encodeURIComponent(key) + '[]';
          return obj[key].map(function (value) {
            return "".concat(encodeURIComponent(key), "[]=").concat(encodeURIComponent(value));
          }).join('&');
        }

        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(obj[key]));
      }).join('&');
    },
    queryStringToObject: function queryStringToObject(queryString) {
      var params = new URLSearchParams(queryString);
      var obj = {};

      var _iterator = _createForOfIteratorHelper(params.entries()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
              key = _step$value[0],
              value = _step$value[1];

          if (key.endsWith('[]')) {
            var realKey = key.slice(0, -2);

            if (!obj[realKey]) {
              obj[realKey] = [];
            } // if there isn't a value don't push anything as it should be treated as an empty array


            if (value) {
              if (!isNaN(value)) {
                value = parseInt(value);
              }

              obj[realKey].push(value);
            }
          } else {
            obj[key] = value === 'null' ? null : isNaN(value) ? value : parseInt(value);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return obj;
    }
  }
};
export default utils;